import { TextAreaInput, TextField, TextFieldInputProps } from "@hex-insights/forms";
import { RadioTextInput } from "../../../Components";
import { StudentMedicalContactFormValues } from "../../FormUtilities";
import { BaseFieldProps } from "../shared";
import { StudentSelectField } from "../Student";

/**
 * Generic props for fields of the StudentMedicalContact model.
 */
type FieldProps<K extends keyof StudentMedicalContactFormValues.Base = keyof StudentMedicalContactFormValues.Base> =
	BaseFieldProps<Pick<StudentMedicalContactFormValues.Base, K>>;

/**
 * Field component for the `name` field of the StudentMedicalContact model.
 */
export function Name({ formState, ...props }: FieldProps<"name">) {
	return <TextField formState={formState} name="name" {...props} />;
}

/**
 * Field component for the `contactType` field of the StudentMedicalContact model.
 */
export function ContactType({ formState, ...props }: FieldProps<"contactType">) {
	return <TextField formState={formState} name="contactType" Input={ContactTypeInput} {...props} />;
}

const contactTypeOptions = [{ value: "Doctor" }, { value: "Dentist" }, { value: "Emergency Contact" }];

function ContactTypeInput(props: TextFieldInputProps) {
	return <RadioTextInput options={contactTypeOptions} {...props} className={undefined} />;
}

/**
 * Field component for the `institutionName` field of the StudentMedicalContact model.
 */
export function InstitutionName({ formState, ...props }: FieldProps<"institutionName">) {
	return <TextField formState={formState} name="institutionName" optional {...props} />;
}

/**
 * Field component for the `phoneNumber` field of the StudentMedicalContact model.
 */
export function PhoneNumber({ formState, ...props }: FieldProps<"phoneNumber">) {
	return <TextField formState={formState} name="phoneNumber" {...props} />;
}

/**
 * Field component for the `emailAddress` field of the StudentMedicalContact model.
 */
export function EmailAddress({ formState, ...props }: FieldProps<"emailAddress">) {
	return <TextField formState={formState} name="emailAddress" optional {...props} />;
}

/**
 * Field component for the `address` field of the StudentMedicalContact model.
 */
export function Address({ formState, ...props }: FieldProps<"address">) {
	return <TextField formState={formState} name="address" optional {...props} />;
}

/**
 * Field component for the `notes` field of the StudentMedicalContact model.
 */
export function Notes({ formState, ...props }: FieldProps<"notes">) {
	return <TextField formState={formState} name="notes" multiLine optional Input={NotesInput} {...props} />;
}

function NotesInput(props: TextFieldInputProps) {
	return <TextAreaInput minRows={2} {...props} />;
}

export namespace Student {
	export type SelectProps = FieldProps<"studentID"> &
		Omit<StudentSelectField.SelectProps<StudentMedicalContactFormValues.Base>, "formState" | "name" | "optional">;

	/**
	 * Field component for the `student` edge of the StudentMedicalContact model.
	 */
	export function Select({ formState, ...props }: SelectProps) {
		return <StudentSelectField.Select formState={formState} name="studentID" {...props} />;
	}
}
